<div class="flex min-h-screen items-center justify-center bg-slate-50 px-4 py-16">
  <div class="w-full max-w-md">

    <!-- Card -->
    <div class="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-lg">

      <!-- Logo -->
      <div class="border-b border-slate-100 px-8 py-6">
        <span class="text-xl font-bold tracking-tight text-slate-900">KernalHQ</span>
      </div>

      <!-- Checking -->
      <div *ngIf="state === 'checking' || state === 'accepting'" class="px-8 py-10 text-center">
        <lucide-icon name="loader" [size]="32" class="mx-auto mb-4 animate-spin text-violet-500" [strokeWidth]="2"></lucide-icon>
        <p class="text-sm font-medium text-slate-700">Verifying your invitation…</p>
      </div>

      <!-- Success -->
      <div *ngIf="state === 'success'" class="px-8 py-10 text-center">
        <div class="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-emerald-100">
          <lucide-icon name="circle-check" [size]="28" class="text-emerald-500" [strokeWidth]="2"></lucide-icon>
        </div>
        <h1 class="mb-2 text-xl font-bold text-slate-900">You're in!</h1>
        <p class="mb-6 text-sm text-slate-500">
          You've joined <strong class="text-slate-800">{{ orgName }}</strong> on KernalHQ.
        </p>
        <button
          (click)="goToDashboard()"
          class="w-full rounded-xl bg-violet-600 px-4 py-3 text-sm font-semibold text-white transition hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-violet-500 focus:ring-offset-2"
        >
          Go to dashboard
        </button>
      </div>

      <!-- Unauthenticated -->
      <div *ngIf="state === 'unauthenticated'" class="px-8 py-10 text-center">
        <div class="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-amber-100">
          <lucide-icon name="lock" [size]="28" class="text-amber-500" [strokeWidth]="2"></lucide-icon>
        </div>
        <h1 class="mb-2 text-xl font-bold text-slate-900">Sign in to accept</h1>
        <p class="mb-6 text-sm text-slate-500">
          Sign in or create an account using the email address this invitation was sent to.
        </p>
        <div class="space-y-3">
          <button
            (click)="goToSignIn()"
            class="w-full rounded-xl bg-violet-600 px-4 py-3 text-sm font-semibold text-white transition hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-violet-500 focus:ring-offset-2"
          >
            Sign in
          </button>
          <button
            (click)="goToSignUp()"
            class="w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-slate-300 focus:ring-offset-2"
          >
            Create account
          </button>
        </div>
      </div>

      <!-- Error -->
      <div *ngIf="state === 'error'" class="px-8 py-10 text-center">
        <div class="mx-auto mb-5 flex h-14 w-14 items-center justify-center rounded-full bg-red-100">
          <lucide-icon name="circle-x" [size]="28" class="text-red-500" [strokeWidth]="2"></lucide-icon>
        </div>
        <h1 class="mb-2 text-xl font-bold text-slate-900">Couldn't accept invitation</h1>
        <p class="mb-6 text-sm text-slate-500">{{ errorMessage }}</p>
        <button
          (click)="goToDashboard()"
          class="w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-slate-300 focus:ring-offset-2"
        >
          Go to dashboard
        </button>
      </div>

    </div>

  </div>
</div>
